import { render, staticRenderFns } from "./TradeHash.m.vue?vue&type=template&id=5d5c3c52"
import script from "./TradeHash.m.vue?vue&type=script&lang=js"
export * from "./TradeHash.m.vue?vue&type=script&lang=js"
import style0 from "./TradeHash.m.vue?vue&type=style&index=0&id=5d5c3c52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports